
(async () => {
  const renderYoptoBalance = function (balance) {
    let desktopSwellNode = document.querySelectorAll('.header-swell-point-balance');
    let mobileSwellNode = document.querySelectorAll('.mobile-header-swell-point-balance');
    if (balance == 0 || balance == '0') {
      desktopSwellNode.forEach(item => item.innerHTML = 'Rewards');
      mobileSwellNode.forEach(item => item.innerHTML = 'My Rewards');
    } else {
      desktopSwellNode.forEach(item => item.innerHTML = balance + '&nbsp;Points');
      mobileSwellNode.forEach(item => item.innerHTML = balance + '&nbsp;Points');
    }
  };
  
  const waitForLocalStorageItem = (key) => {
    return new Promise((resolve) => {
      const interval = setInterval(() => {
        const value = localStorage.getItem(key);
        if (value !== null) {
          clearInterval(interval);
          resolve(value);
        }
      }, 500);
    });
  };
  
  const value = await waitForLocalStorageItem("swell-points-balance");
  renderYoptoBalance(value);
})();